<ng-container *ngIf="isBrowser; else serverHtmlContent">
  <div #markdownContainer>
    <markdown [data]="markdownData"></markdown>
  </div>
</ng-container>

<ng-template #serverHtmlContent>
  <div [innerHTML]="markdownData"></div>
</ng-template>
